$ = jQuery;
//ヘッダーの背景をスクロールで変化
$(function(){

    var header = $('.header');

    header_offset = header.offset();

    header_height = header.height();

    $(window).scroll(function () {

    // if($(window).scrollTop() > header_offset.top + header_height) {
    if($(window).scrollTop() > header_offset.top) {

    header.addClass('scroll');

    }else {

    header.removeClass('scroll');

    }

    });

});

//レスポンシブのナビ
$(function(){
  $('.res-gnav').hide();
  $('.Toggle').click(function() {
      $(this).toggleClass('active');
      $('.res-gnav').toggleClass('open').fadeToggle(300);

      if ($(this).hasClass('active')) { // ナビを開くときの処理
          $("html").addClass("is-fixed"); //ナビ表示時は固定
      } else {
          $("html").removeClass("is-fixed");
      }
  });
});
// ウインドウ幅1400px以上の時スマホメニュー非表示
setTimeout(function () {
  $(window).on("resize", function() {
    var w = $(window).width();
    if (w > 1400) {  // ブレークポイント（単位：px）
      $('.Toggle').removeClass('active');
      $('html').removeClass('is-fixed');
      $('.res-gnav').removeClass('open').fadeOut(300);
    }
  });
}, 500);//ページ上部からの距離を取得

//divタグをリンクにする
$('.article-all').click(function() {
    location.href = $(this).attr('data-url');
});

/*
https://recooord.org/fadein-window-scroll/
$で値を取得してフェードインを実装。
ターゲットの位置までスクロールすると「 opacity 」が「 1 」に。
「 transform 」の値も「 translateY(0) 」になり、下にずらしていたターゲットが通常の位置に戻ります。
*/
$(function(){
    function animation(){
      $('.fadeIn').each(function(){
        //ターゲットの位置を取得
        var target = $(this).offset().top;
        //スクロール量を取得
        var scroll = $(window).scrollTop();
        //ウィンドウの高さを取得
        var windowHeight = $(window).height();
        //ターゲットまでスクロールするとフェードインする
        if (scroll > target - windowHeight){
          $(this).css('opacity','1');
          $(this).css('transform','translate(0,0)');
        }
      });
    }
    animation();
    $(window).scroll(function (){
      animation();
    });
});

//gnavのa要素のhrefで2番目の「/」で区切られる部分の値が同じときactive
$(document).ready(function() {
    var activeUrl = location.pathname.split("/news/")[1];
      navList = $(".category-list>li").find("a");

    navList.each(function(){
        if( $(this).attr("href").split("/news/")[1] == activeUrl ) {
        $(this).addClass("active");
      };
  });
});

/*==================================================
ページトップボタン
==================================================*/
$(document).ready(function () {
  // if (!navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
    const w = $(window).width();
    $(".pagetop").hide();
    $(window).on("scroll", function () {

      // 高さの計算
      var scrollHeight = $(document).height(); // ドキュメント全体の高さ
      var scrollPosition = $(window).height() + $(window).scrollTop(); // 現在地
      var footHeight = $("footer").innerHeight(); // フッターの高さ

      // フッター付近での処理
      if (w > 991) {
        if ($(this).scrollTop() > 100) {
          $(".pagetop").fadeIn("fast");
        } else {
          $(".pagetop").fadeOut("fast");
        }
        if (scrollHeight - scrollPosition <= footHeight) {
          $(".pagetop").css({
            "position": "absolute",
            "bottom": footHeight + 50
          });
        } else {
          $(".pagetop").css({
            "position": "fixed",
            "bottom": "2rem"
          });
        }
      }
      if (w < 576) {
        if (scrollHeight - scrollPosition <= footHeight) {
          $(".follow-links").removeClass('active');
        } else {
          $(".follow-links").addClass('active');
        }
      }
    });
  // }
});



/*==================================================
アンカーリンク 別ページ
==================================================*/
$(window).on('load', function() {
  var url = $(location).attr('href');
  if(url.indexOf("#") != -1){
    var anchor = url.split("#");
    var target = $('#' + anchor[anchor.length - 1]);
    var screenWidth = window.innerWidth;
    var offsetTop = 0;
    if (screenWidth >= 1440) {
      offsetTop = 130;
    }else if(screenWidth <= 1441) {
      offsetTop = 90;
    }else if(screenWidth < 768) {
      offsetTop = 60;
    }
    if(target.length){
      var pos = Math.floor(target.offset().top) - offsetTop;
      $("html, body").animate({scrollTop:pos}, 500);
    }
  }
});
if($('#toc').length > 0){
  $(function(){
    var counter = 0;
    $('.wysiwyg-contents h2, .wysiwyg-contents h3, .wysiwyg-contents h4').each(function(){
        counter++;
    });
    if(counter > 1) {
      $("#toc")
        .append('<p class="index-title">目次<span>[<a href="#" class="toggle-index"></a>]</spa></p><ul class="index"></ul>');
    }else {
      $('#toc').hide();
    }

    // .toc-target内にある見出し（h2, h3, h4）を、目次に入れます
    $(".wysiwyg-contents h2, .wysiwyg-contents h3, .wysiwyg-contents h4").each(function(i) {
      var current = $(this);
      current.attr("id", "title" + i);
      if (current.get(0).tagName == 'H2'){
        $("#toc ul.index").append('<li class="level1"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
      }
      if (current.get(0).tagName == 'H3'){
        $("#toc ul.index").append('<li class="level2"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
      }
      if (current.get(0).tagName == 'H4'){
        $("#toc ul.index").append('<li class="level3"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
      }
    });
    $('.toggle-index').on('click', function() {
      $(this).toggleClass('show');
      $('ul.index').toggle('slow');
    });
  });
}

/*==================================================

ページ内リンク
==================================================*/
$(function(){
  var screenWidth = window.innerWidth;
  var headerHight = 0;//ヘッダの高さ
  if (screenWidth >= 1400) {
    headerHight = 130;
  }else if(screenWidth <= 1401 && screenWidth >= 767) {
    headerHight = 90;
  }else if(screenWidth <= 768) {
    headerHight = 60;
  }
  $('a[href^="#"]').on("click", function (event) {
    event.preventDefault();
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    $("html, body").animate({ scrollTop: position }, 1000, "swing");
    return false;
  });
});

/*==================================================

リンクブロック内にaタグを置きたい
==================================================*/
$(function ($) {
  $('.js-section-wrap-label').on('click', function(e){
    //伝播をストップ
    e.stopPropagation();
    e.preventDefault();

    //リンクを取得して飛ばす
    location.href = $(this).attr('data-href');
  });
});

/*==================================================

お問い合わせの年収の必須の取り外し
==================================================*/
$(function ($) {
  $('input[name="your-gender"]:eq(1)').on('click',function() {
      if ($(this).prop('checked')) {
        $('label.income').append('<span>必須</span>');
      }
  });
  $('input[name="your-gender"]:eq(0)').on('click',function() {
      if ($(this).prop('checked')) {
        $('label.income span').remove();
      }
  });
});

/*==================================================

よくあるご質問
==================================================*/
if($('#singupFaqTop').length && $(window).width() <= 767) {
    $(document).ready(function() {
        $('html, body').animate({
            scrollTop: $('#singupFaqTop').offset().top
        }, 1000); // 1000ミリ秒 (1秒) でスクロール
    });
}